import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { IOperationDashboardDetails, IScheduledMoveInsFilterListModel, IScheduledMoveInsListModel,
  IDashboardSettingsDetailsByUser, IDashboardSettingFollowUps, IDashboardSettingAuctions,
  IDashboardFollowsUpsFiliter, IDashboardAuctionsFiliter,
  IMoveOutList, IScheduleMoveOutsFilter, IFacilityOccupancyModel, IUnitTypeAvailabilityFilterListModel, IUnitSizeAvailabilityListModel, IAccountReceivables, IReservationConversionRate, IRentalsForTheMonth, IBlacklistedCustomer, IOpsDashboardBlacklistFilterModel, IBlackListCustomer, IAccountReceivablesSnapshot, ISiteOccupancyWidget, ICampaignDashFilter, ILeadConversionActivity, IPtiViewPort, IGateControl, IConversionDetails, IPageModel,
  IOpenTechActionGroupResponseModel} from 'src/app/Shared/models/DashboardModel';
import {AppService} from '../app.service';
import { ISaveDeleteResponse } from 'src/app/Shared/interface';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private baseURL = this.appService.config.apiBaseUrl;
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient,
              private appinsights: AppInsightsService,
              private appService: AppService) { }

  getOperationDashboardDetails(facilityId: number,): Observable<any> {

    return this.http.get<any>(
      `${this.baseURL}/Dashboard/GetOperationDashboardDetails?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as IOperationDashboardDetails;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }
  getdashboardretailsales(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardRetailSales?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardaccountreceivables(facilityid) : Observable<IAccountReceivables> {
    return this.http.get<IAccountReceivables>(
      `${this.baseURL}/Dashboard/GetDashboardAccountReceivables?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as IAccountReceivables;
          return occurancelist;
        }),
        catchError(this.handleError)
      );
  }

  getdashboardaccountreceivablesSnapshot(facilityid) : Observable<IAccountReceivablesSnapshot> {
    return this.http.get<IAccountReceivablesSnapshot>(
      `${this.baseURL}/Dashboard/GetDashboardAccountsReceivableSnapshot?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as IAccountReceivablesSnapshot;
          return occurancelist;
        }),
        catchError(this.handleError)
      );
  }

  getDashboardLeadConversionActivity(facilityId) : Observable<ILeadConversionActivity>{
    return this.http.get<ILeadConversionActivity>(
    `${this.baseURL}/Dashboard/GetLeadConversionActivity?facilityId=${facilityId}`,
    { observe: 'response'})
    .pipe(
      map(res =>{
        const conversionData = res.body as ILeadConversionActivity;
        return conversionData;
      }),
      catchError(this.handleError)
    )
  }

  getDashboardPTIViewPort(facilityId,nextStartId) : Observable<IPtiViewPort[]> {
    return this.http.get<IPtiViewPort[]>(
      `${this.baseURL}/Dashboard/GetDashboardPTIViewPort?facilityId=${facilityId}&&nextStartId=${nextStartId}`)
      .pipe(
        map(res =>{
          return res;
        }),
        catchError(this.handleError)
      );
  }
  getPTISiteActivityDetailsList(PtiViewPortFilter) : Observable<IPtiViewPort[]> {
    const url = `${this.baseURL}/Dashboard/GetPTISiteActivityDetailsList`;
    return this.http.post<IPtiViewPort[]>(url,PtiViewPortFilter,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getAllUsersOnSiteForPTIViewport(facilityId) : Observable<IPtiViewPort[]> {
    return this.http.get<IPtiViewPort[]>(
      `${this.baseURL}/Dashboard/GetAllUsersOnSiteForPTIViewport?facilityId=${facilityId}`)
      .pipe(
        map(res =>{
          return res;
        }),
        catchError(this.handleError)
      );
  }

  getGateControlList(facilityId,facilityName) : Observable<IGateControl[]> {
    return this.http.get<IGateControl[]>(
      `${this.baseURL}/Dashboard/GetGateControlList?facilityId=${facilityId}&&facilityName=${facilityName}`)
      .pipe(
        map(res =>{
          return res;
        }),
        catchError(this.handleError)
      );
  }

  controlGateFromPTIViewPort(gateControl) : Observable<ISaveDeleteResponse[]> {
    const url = `${this.baseURL}/Dashboard/ControlGateFromPTIViewPort`;
    return this.http.post<ISaveDeleteResponse[]>(url,gateControl,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  clearUsersOnSiteForPTIViewport(onSite) : Observable<ISaveDeleteResponse> {
    const url = `${this.baseURL}/Dashboard/ClearUsersOnSiteForPTIViewport`;
    return this.http.post<ISaveDeleteResponse>(url,onSite,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  GetFacilityGatesAndRelayDetails(facilityId) : Observable<IOpenTechActionGroupResponseModel[]> {
    return this.http.get<IOpenTechActionGroupResponseModel[]>(
      `${this.baseURL}/OpenTechViewPort/GetFacilityGatesAndRelayDetails?facilityId=${facilityId}`)
      .pipe(
        map(res =>{
          return res;
        }),
        catchError(this.handleError)
      );
  }

  OpenGate(openTechModel) : Observable<ISaveDeleteResponse[]> {
    const url = `${this.baseURL}/OpenTechViewPort/OpenGate`;
    return this.http.post<ISaveDeleteResponse[]>(url,openTechModel,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  CloseGate(openTechModel) : Observable<ISaveDeleteResponse[]> {
    const url = `${this.baseURL}/OpenTechViewPort/CloseGate`;
    return this.http.post<ISaveDeleteResponse[]>(url,openTechModel,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  HoldGate(openTechModel) : Observable<ISaveDeleteResponse[]> {
    const url = `${this.baseURL}/OpenTechViewPort/HoldGate`;
    return this.http.post<ISaveDeleteResponse[]>(url,openTechModel,this.options)
    .pipe(
      map(res =>{
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getdashboardSiteOccupancyWidget(facilityid): Observable<ISiteOccupancyWidget> {
    return this.http.get<ISiteOccupancyWidget>(
      `${this.baseURL}/Dashboard/GetDashboardSiteOccupancy?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as ISiteOccupancyWidget;
          return occurancelist;
        }),
        catchError(this.handleError)
      );
  }

  getdashboardschedulemoveouts(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardScheduledMoveouts?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );

  }
  getdashboardrecentitems(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardRecentItems?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardfollowups(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardFollowUps?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardreservationrate(facilityid) : Observable<IReservationConversionRate> {
    return this.http.get<IReservationConversionRate>(
      `${this.baseURL}/Dashboard/GetDashboardReservationConversionRate?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as IReservationConversionRate;
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardauctions(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardAuctions?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboarschedulemoveins(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardScheduledMoveIns?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardrentalsformonth(facilityid) : Observable<IRentalsForTheMonth> {
    return this.http.get<IRentalsForTheMonth>(
      `${this.baseURL}/Dashboard/GetDashboardRentalsForTheMonth?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as IRentalsForTheMonth;
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getoperationsoccupancy(facilityId:number):Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Store/GetFacilityOccupancyOperations?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any[];
          return listdata;
        }),
        catchError(this.handleError)
      );

  }

  getOperationDashboarScheduleMoveIns(moveinListFilter: IScheduledMoveInsFilterListModel): Observable<IScheduledMoveInsListModel> {
    const url = `${this.baseURL}/Dashboard/GetOperationDashboarScheduleMoveIns`;
    return this.http.post<IScheduledMoveInsListModel>(url, moveinListFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }
  getOperationDashboardBlacklist(moveinListFilter: IOpsDashboardBlacklistFilterModel): Observable<IBlackListCustomer> {
    const url = `${this.baseURL}/Dashboard/GetOperationDashboardblacklistcustomers`;
    return this.http.post<IBlackListCustomer>(url, moveinListFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }
  getunitlocklist(facilityId:number):Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetUnitLockUnLockList?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any[];
          return listdata;
        }),
        catchError(this.handleError)
      );

  }

  getOperationUnitSizeavailabilitylist(unitlistfilter: IUnitTypeAvailabilityFilterListModel): Observable<IUnitSizeAvailabilityListModel> {
    const url = `${this.baseURL}/Dashboard/GetUnitSizeAvailabilityList`;
    return this.http.post<IUnitSizeAvailabilityListModel>(url, unitlistfilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }

  getDashboardSettingsDetailsByUser( userID: number): Observable<IDashboardSettingsDetailsByUser> {


    return this.http.get<IDashboardSettingsDetailsByUser>(
      `${this.baseURL}/DashboardSettings/GetDashboardSettingsDetailsByUser?userID=${userID}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as IDashboardSettingsDetailsByUser;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getfacilityoccupancelist(facilityid, unittstausid,linquent) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Store/GetFacilityOccupancyOperationsList?facilityId=${facilityid}&unitStatusId=${unittstausid}&deliquentUnit=${linquent}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardunitlock(facilityid) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardUnitLockUnLock?facilityId=${facilityid}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );


  }
  getdashboardunittypeavailability(facilityid, iscallcenter) : Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Dashboard/GetDashboardUnitTypeAvailability?facilityId=${facilityid}&callcentrebit=${iscallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const occurancelist = res.body as any[];
          return occurancelist;
        }),
        catchError(this.handleError)
      );
  }

  getNewslist(facilityId:number, startDate):Observable<any>{
    return this.http.get<any>(
      `${this.baseURL}/News/GetNewsList?facilityId=${facilityId}&startDate=${startDate}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const Newslist = res.body as any;
          return Newslist;
        }),
        catchError(this.handleError)
      );
    }

    getNewslistForOp(facilityId:number, startDate):Observable<any>{
      return this.http.get<any>(
        `${this.baseURL}/News/GetNewsListForOp?facilityId=${facilityId}&startDate=${startDate}`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const Newslist = res.body as any;
            return Newslist;
          }),
          catchError(this.handleError)
        );
      }

  getdashboardBlacklistedcustomers(facilityId:number):Observable<IBlacklistedCustomer>{
    return this.http.get<IBlacklistedCustomer>(
      `${this.baseURL}/Dashboard/GetDashboardBlacklistedCustomers?facilityId=${facilityId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const customerlist = res.body as IBlacklistedCustomer;
          return customerlist;
        }),
        catchError(this.handleError)
      );
  }

  getOperationDashboarFollowUps(followUpsListFilter: IDashboardFollowsUpsFiliter): Observable<IDashboardSettingFollowUps> {
    const url = `${this.baseURL}/Dashboard/GetOperationDashboardFollowUps`;
    return this.http.post<IDashboardSettingFollowUps>(url, followUpsListFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }
  getOperationDashboarAuctions(auctionListFilter: IDashboardAuctionsFiliter): Observable<IDashboardSettingAuctions> {
    const url = `${this.baseURL}/Dashboard/GetOperationDashboardAuctions`;
    return this.http.post<IDashboardSettingAuctions>(url, auctionListFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }

  getOperationDashboardScheduleMoveOuts(moveOutFilter: IScheduledMoveInsFilterListModel): Observable<IScheduledMoveInsListModel > {
    const url = `${this.baseURL}/Dashboard/GetOperationDashboardScheduleMoveOuts`;
    return this.http.post<IScheduledMoveInsListModel>(url, moveOutFilter, this.options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );

  }

  getInquiryDetailsById( ID: number,isCallcenter): Observable<any> {

    return this.http.get<any>(
      `${this.baseURL}/Prospects/GetInquiryDetailsById?id=${ID}&CallCenter=${isCallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getReservationDetailsById( reservationId: number,isCallcenter): Observable<any> {

    return this.http.get<any>(
      `${this.baseURL}/Prospects/GetReservationDetailsById?reservationId=${reservationId}&CallCenter=${isCallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getReservationDetailsByTenantId( tenantId: any, isCallcenter): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Prospects/GetReservationDetailsByTenantId?tenantId=${tenantId}&CallCenter=${isCallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getReservationDetailsByReservationNumber(reservationNumber, facilityId,isCallcenter): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Prospects/GetReservationDetailsByReservationNumber?reservationNumber=${reservationNumber}&&reservationFacilityId=${facilityId}&CallCenter=${isCallcenter}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const listdata = res.body as any;
          return listdata;
        }),
        catchError(this.handleError)
      );
  }

  getCamPaignTrackerfilters(): Observable<any> {
    return this.http.get<any>(
        `${this.baseURL}/CampaignTracker/GeFilterforCampaignDashboard`,
        { observe: 'response' })
        .pipe(
            map(res => {
                const filterInfo = res.body as any;
                return filterInfo;
            }),
            catchError(this.handleError)
        );
}

  dashboardClickToPayList(campaignDashFilter: ICampaignDashFilter): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/CampaignTracker/GetCampaignClickToPayCountList`;
    return this.http.post<any>(url, campaignDashFilter, options)
      .pipe(
        map(res => {
          const dashboardList = res as any[];
          return dashboardList;
        }),
        catchError(this.handleError)
      );
  }

  dashboardClickToCallList(campaignDashFilter: ICampaignDashFilter): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/CampaignTracker/GetCampaignClickToCallCountList`;
    return this.http.post<any>(url, campaignDashFilter, options)
      .pipe(
        map(res => {
          const dashboardList = res as any[];
          return dashboardList;
        }),
        catchError(this.handleError)
      );
  }
  
  dashboardCampaignStatistics(campaignDashFilter: ICampaignDashFilter): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/CampaignTracker/GetCampaignStatistics`;
    return this.http.post<any>(url, campaignDashFilter, options)
      .pipe(
        map(res => {
          const dashboardList = res as any[];
          return dashboardList;
        }),
        catchError(this.handleError)
      );
  }

  dashboardCampaignVolumeData(campaignDashFilter: ICampaignDashFilter): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/CampaignTracker/GetCampaignVolume`;
    return this.http.post<any>(url, campaignDashFilter, options)
      .pipe(
        map(res => {
          const dashboardList = res as any[];
          return dashboardList;
        }),
        catchError(this.handleError)
      );
  }

  getMarketingLicenseDetails(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/store/getLicenseDetailsForMarketing`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const licenseDetails = res.body as any;
          return licenseDetails;
        }),
        catchError(this.handleError)
      );
  }  

  getInquiryConversionStatistics(pageModel : IPageModel): Observable<IConversionDetails[]> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Dashboard/GetInquiryConversionStatistics`;
    return this.http.post<IConversionDetails[]>(url, pageModel, options)
      .pipe(
        map(res =>{
          const inquiryConversionData = res as IConversionDetails[];
          return inquiryConversionData;
        }),
        catchError(this.handleError)
      )
  }

  getReservationConversionStatistics(pageModel : IPageModel) : Observable<IConversionDetails[]> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/Dashboard/GetReservationConversionStatistics`;
      return this.http.post<IConversionDetails[]>(url, pageModel, options)
      .pipe(
        map(res =>{
          const reservationConversionData = res as IConversionDetails[];
          return reservationConversionData;
        }),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

  getFacilityAuditLicenseDetails(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/store/GetFacilityAuditSettings`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const licenseDetails = res.body as any;
          return licenseDetails;
        }),
        catchError(this.handleError)
      );
  }
}
